export default {
    message: {
        tiers: {
            t1: {
                label: "Stand-alone",
                desc: "<p>Uniforme toegang tot alle virtuele, web- en SaaS-apps en bescherming van gebruikers, apps en data met end-to-end contextafhankelijke securitymechanismen.</p><p>Biedt een VPN-loze proxy en SSO voor toegang tot web-, SaaS-, virtuele en mobiele apps, evenals bescherming tegen schadelijke content, keyloggers en malware die screenshots maakt.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Complete workspace-oplossing voor mensen die wel een volledige digitale workspace met fijnmazige security nodig hebben, maar geen virtuele apps en desktops.</p><p>Met de functionaliteit van Workspace Standard, plus geavanceerde securitymechanismen voor SaaS en web, Unified Endpoint Management en Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Uitgebreide workspace-oplossing met opties voor hybride implementatie van Citrix Virtual Apps and Desktops.</p><p>Met de functionaliteit van Workspace Premium, plus cloudbeheer voor Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}